import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("astrolift_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("astrolift_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    if (err?.response?.status === 402) {
      if (window.location.pathname !== "/pricing") {
        window.location.href = "/pricing?quota=1";
      }
    }
    return Promise.reject(err);
  },
);

export function imageUrl(id, which, fmt = "jpg") {
  const token = localStorage.getItem("astrolift_token");
  return `${API}/images/${id}/file/${which}?fmt=${fmt}&auth=${encodeURIComponent(token || "")}`;
}

export function exportUrl(id, fmt) {
  const token = localStorage.getItem("astrolift_token");
  return `${API}/images/${id}/export?fmt=${fmt}&auth=${encodeURIComponent(token || "")}`;
}
